import React, { useState } from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableColumn,
  TableRow,
  TableCell
} from "@heroui/table";
import {Form, Input, Button} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@heroui/modal";
import { EyeSlashFilledIcon } from './EyeSlashFilledIcon';
import { EyeFilledIcon } from './EyeFilledIcon';

const SettingsModal = ({user, setUser, dismissModal}) => {
  const [error, setError] = useState();
  const [passwd, setPasswd] = useState();
  const [pwConfirm, setPwConfirm] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);

  const toggleVisibility = () => setIsVisible(!isVisible);
  const toggleConfirmVisibility = () => setIsConfirmVisible(!isConfirmVisible);

  const subscribe = async () => {
    const d = await fetch('/api/v1/users/subscribe', {method: 'PUT'});
    if (d.status === 200) {
      const dj = await d.json();
      alert('You are now subscribed to our email digests. Feel free to unsubscribe at any time.');
      setUser(dj['user']);
    }
  };

  const unsubscribe = async () => {
    const d = await fetch(`/api/v1/unsubscribe?email=${encodeURIComponent(user?.email)}&redirect=false`);
    if (d.status === 200) {
      const dj = await d.json();
      alert('You have unsubscribed from our email digests.');
      setUser(dj['user']);
    }
  };

  const updatePassword = async () => {
    // Do validations
    if (passwd !== pwConfirm) {
      setError('Passwords do not match');
      return;
    }
    if (!passwd) {
      setError('Must specify a password!');
      return;
    }
    if (passwd.length < 8) {
      setError('Password must be 8 or more characters');
      return;
    }
    // Post to the API endpoint to change the password.
    const fd = new FormData();
    fd.append('password', passwd);
    fd.append('password_confirm', pwConfirm);
    const d = await fetch('/api/v1/users/update_password', {method: 'PUT', body: fd});
    if (d?.status === 200 || d?.status > 300) {
      alert('Password changed successfully. You will need to reauthenticate with your new password.');
      window.location.reload();
    }
  };

  return (
    <Form onSubmit={updatePassword}>
      <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>
            Settings
          </ModalHeader>
          <ModalBody>
            <Table aria-label="Settings" color='danger' shadow="md">
              <TableHeader style={{height: '0px', padding: '0px', margin: '0px'}} columns={2}>
                <TableColumn style={{height: '0px'}}> </TableColumn>
                <TableColumn style={{height: '0px'}}> </TableColumn>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell className='htr'>Email: </TableCell>
                  <TableCell className='htr'>{user.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className='htr'>UserID: </TableCell>
                  <TableCell className='htr'><span style={{fontSize: '13px'}}>{user.id}</span></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className='htr'>Created: </TableCell>
                  <TableCell className='htr'>{new Date(user.created_at).toDateString().split(' ').slice(1, 4).join(' ')}</TableCell>
                </TableRow>
                 { (!user.provider || user.provider?.indexOf('le') === -1) &&
                <TableRow>
                  <TableCell className='htr' style={{verticalAlign: 'top'}}>
                    <div style={{verticalAlign: 'top', width: '136px', marginLeft: '-5px', display: 'inline-block', padding: '4px'}}>
                      <Input validationBehavior='native'
                             isInvalid={error}
                             isRequired
                             minLength='8'
                             label='New password'
                             defaultValue=''
                             size='sm'
                             onChange={(d) => {setError(''); setPasswd(d.target.value)}}
                             type={isVisible ? "text" : "password"}
                             endContent={
                               <button aria-label="toggle password visibility"
                                       className="focus:outline-none"
                                       type="button"
                                       onClick={toggleVisibility}
                               >
                                 {isVisible ? (<EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />)
                                            : (<EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />)}
                               </button>
                             }
                      />
                    </div>
                  </TableCell>
                  <TableCell className='htr'>
                    <div style={{width: '130px', display: 'inline-block', padding: '0px', marginLeft: '-20px', marginRight: '26px'}}>
                      <Input validationBehavior='native'
                             isInvalid={error}
                             isRequired
                             minLength='8'
                             label='Confirm'
                             defaultValue=''
                             size='sm'
                             errorMessage={error}
                             onChange={(d) => {setError(''); setPwConfirm(d.target.value)}}
                             type={isConfirmVisible ? "text" : "password"}
                             endContent={
                               <button aria-label="toggle password visibility"
                                       className="focus:outline-none"
                                       type="button"
                                       onClick={toggleConfirmVisibility}
                               >
                                 {isConfirmVisible ? (<EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />)
                                            : (<EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />)}
                               </button>
                             }

                      />
                    </div>
                    <div style={{position: 'absolute', top: '18px', left: '132px'}}>
                      <Button type='submit' size='sm' onPress={() => updatePassword()}>Update</Button>
                    </div>
                  </TableCell>
                </TableRow>
                }
              </TableBody>
            </Table>
            { user?.subscribe_digests
              ?
                <Button type='submit' size='sm' onPress={() => unsubscribe()}>Unsubscribe from email digests</Button>
              :
                <Button type='submit' size='sm' onPress={() => subscribe()}>Subscribe to email digests</Button>
            }
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Form>
  );
}

export default SettingsModal;
